var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUrl({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "19px",
    viewBox: "0 0 24 19",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "F9D7560B-898F-42AC-A1B4-04845A14E9C8") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SitePges",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "SummarizationPage",
    transform: "translate(-620.000000, -479.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(374.000000, 464.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(210.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "link",
    transform: "translate(36.000000, 15.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.14148458,4.37727375 C8.34959812,2.16955735 12.0191969,2.16955735 14.2273104,4.37727375 C16.213024,6.36298737 16.5069097,9.52821487 14.8746531,11.8117855 L14.8309674,11.8753284 C14.4219104,12.4432425 13.6276249,12.578271 13.0597108,12.169214 C12.4878253,11.760157 12.3527968,10.9658715 12.7618538,10.3979574 L12.8055395,10.3344146 C13.7149963,9.05958646 13.5720249,7.3161299 12.4639967,6.2081017 C11.2169686,4.96107355 9.18756927,4.96107355 7.93656969,6.2081017 L3.48062833,10.6680145 C2.22923161,11.8832712 2.22923161,13.944442 3.48062833,15.1954415 C4.5846851,16.3034697 6.33211308,16.4464411 7.6029698,15.5369843 L7.66651264,15.4575557 C8.23839816,15.0842416 9.03268361,15.2152987 9.43776918,15.7871842 C9.84682619,16.3590697 9.71576909,17.1533552 9.14388357,17.5624122 L9.08034073,17.6060979 C6.76102723,19.2383545 3.66728541,18.9762403 1.68196893,16.9944981 C-0.560656311,14.7506417 -0.560656311,11.1128143 1.68196893,8.87292938 L6.14148458,4.37727375 Z M17.8571949,14.2621561 C15.6133385,16.5060125 11.9794826,16.5060125 9.73562623,14.2621561 C7.74991261,12.2764425 7.49176984,9.14695786 9.12402643,6.8633872 L9.16771213,6.79984436 C9.54102629,6.23193027 10.3353117,6.09690174 10.9389687,6.50595875 C11.5108542,6.87927291 11.6458827,7.67355835 11.2368257,8.27721529 L11.19314,8.34075813 C10.2836832,9.57984343 10.4266546,11.3590428 11.5346828,12.467071 C12.7817109,13.7140992 14.8111102,13.7140992 16.0621098,12.467071 L20.5180512,8.00715824 C21.7690508,6.75615866 21.7690508,4.69498793 20.5180512,3.47973119 C19.4139944,2.37289442 17.6665664,2.22833447 16.3957097,3.13818845 L16.3321669,3.18187415 C15.7602813,3.59093116 14.9659959,3.42413121 14.5609103,2.88719425 C14.1518533,2.31610301 14.2829104,1.52221471 14.8547959,1.11434913 L14.9183388,1.06986915 C17.2019094,-0.56195059 20.3313941,-0.303053249 22.3171077,1.68226323 C24.5609641,3.92453104 24.5609641,7.56235839 22.3171077,9.80224335 L17.8571949,14.2621561 Z",
    id: "Shape"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUrl);
export default __webpack_public_path__ + "static/media/url.44fc9dab867416f808a0a9364c50e551.svg";
export { ForwardRef as ReactComponent };